import { render, staticRenderFns } from "./media_premium_button.vue?vue&type=template&id=72af7697&scoped=true"
import script from "./media_premium_button.vue?vue&type=script&lang=js"
export * from "./media_premium_button.vue?vue&type=script&lang=js"
import style0 from "./media_premium_button.vue?vue&type=style&index=0&id=72af7697&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af7697",
  null
  
)

export default component.exports